import { GraphQLRequestBody } from '@shared/types/graphql-request-type';

export const isGraphQLRequestBody = (
  body: unknown,
): body is GraphQLRequestBody => {
  return (
    body !== null &&
    typeof body === 'object' &&
    'operationName' in body &&
    typeof (body as GraphQLRequestBody).operationName === 'string'
  );
};
